import { createRouter, createWebHistory } from 'vue-router';
import Login from '@/components/Login.vue'; // Login page
import LoggedHome from '@/components/LoggedHome.vue'; // Logged-in home
import Support from '@/components/Support.vue'; // Support page
import Profile from '@/components/Profile.vue'; // Profile page
import Courses from '@/components/Courses.vue';
import Notifications from '@/components/Notifications.vue';
import Trades from '@/components/Trades.vue';
import Analysis from '@/components/Analysis.vue';
import MudaSenha from '@/components/MudaSenha.vue';
import LandingPage from '@/components/LandingPage.vue';
import Dashboard from '@/components/Dashboard.vue';

const routes = [
  { 
    path: '/', 
    name: 'LoggedHome', 
    component: LoggedHome ,
    meta: {requiresAuth: true }
  },
  { path: '/login', name: 'Login', component: Login },

  // { path: '/loggedhome',
  //   name: 'LoggedHome',
  //   component: LoggedHome,
  //   meta: {requiresAuth: true }
  // }, //
  { path: '/support',
    name: 'Support',
    component: Support,
    meta: { requiresAuth: true }
  }, // 
  { path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  }, // 
  { path: '/courses',
    name: 'Courses',
    component: Courses,
    meta: { requiresAuth: true }
  }, // 
  { path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: { requiresAuth: true }
  }, // 
  { path: '/trades',
    name: 'Trades',
    component: Trades,
    meta: { requiresAuth: true }
  }, // 
  { path: '/analysis',
    name: 'Analysis',
    component: Analysis,
    meta: { requiresAuth: true }
  }, // 
  { path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  }, // 
  {
    path: '/changePassword',
    name: 'mudaSenha',
    component: MudaSenha,
    meta: { requiresAuth: false } //esse aqui vai ficar true mesmo, nao mudar 
  },
  {
    path: '/landingPage',
    name: 'LandingPage',
    component: LandingPage,
    meta: { requiresAuth: false } //vai ficar true 
  },
  // Entradas públicas do novo convite são interceptadas antes do fallback autenticado.
  { path: '/convite', component: LandingPage },
  { path: '/convite-checkout', component: LandingPage },
  { path: '/tabuleiro', component: LandingPage },
  // ⚠️ SEMPRE DEIXE ESSA ROTA POR ÚLTIMO
  {
    path: '/:pathMatch(.*)*',  // Captura qualquer rota não registrada
    redirect: '/'               // Redireciona para "/"
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

//bagulho pra ver se ta autenticado 

const publicInvitationRoutes = {
  '/convite': 'https://app-nuxt-cic.pages.dev/convite',
  '/convite-checkout': 'https://app-nuxt-cic.pages.dev/convite-checkout',
  '/landingPage': 'https://app-nuxt-cic.pages.dev/convite',
  '/tabuleiro': 'https://app-nuxt-cic.pages.dev/convite'
};

router.beforeEach((to, from, next) => {
  const invitationTarget = publicInvitationRoutes[to.path.replace(/\/$/, '')];
  if (invitationTarget) {
    window.location.replace(invitationTarget + to.fullPath.slice(to.path.length));
    return;
  }
  const isAuthenticated = !!(localStorage.getItem('token') || sessionStorage.getItem('token'));

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next({ name: 'Login' }); // se n tive logado vai pro login
  } else if (to.name === 'Login' && isAuthenticated) {
    next({ name: 'LoggedHome'});
  }else{
    next();
  }
});

export default router;




